import { useRouteError } from 'react-router';
import { LinkButton } from '@/components/app/LinkButton';
import { Buildings2, Lock1, SearchStatus, Warning2 } from 'iconsax-reactjs';
import { Button, EmptyState } from '@/components/ui';
import { useDocumentTitle } from '@/lib/hooks/useDocumentTitle';
import styles from '@/app/app.module.css';

export function ForbiddenPage() {
  useDocumentTitle('Access denied');
  return (
    <div className={styles.page}>
      <EmptyState
        icon={<Lock1 size={40} color="currentColor" variant="Bulk" />}
        title="You don’t have access to this area"
        description="Your roles in this organization do not include the permissions required for this page. If you believe you need access, contact your school or district administrator."
        primaryAction={<LinkButton to="/dashboard">Back to dashboard</LinkButton>}
      />
    </div>
  );
}

export function NotFoundPage() {
  useDocumentTitle('Page not found');
  return (
    <div className={styles.page}>
      <EmptyState
        icon={<SearchStatus size={40} color="currentColor" variant="Bulk" />}
        title="Page not found"
        description="The page you requested does not exist or has moved."
        primaryAction={<LinkButton to="/dashboard">Go to dashboard</LinkButton>}
      />
    </div>
  );
}

export function NoOrganizationPage() {
  useDocumentTitle('No organization access');
  return (
    <div className={styles.page}>
      <EmptyState
        icon={<Buildings2 size={40} color="currentColor" variant="Bulk" />}
        title="No active organization"
        description="Your account is not currently a member of an active organization, or your membership was suspended. Ask an administrator to invite you. You can still manage your profile and sessions."
        primaryAction={<LinkButton to="/account/security">Security & sessions</LinkButton>}
      />
    </div>
  );
}

/** Router-level error boundary (unexpected rendering errors). */
export function RouteErrorPage() {
  const error = useRouteError();
  useDocumentTitle('Something went wrong');
  if (import.meta.env.DEV) console.error(error);
  return (
    <div className={styles.fullPage}>
      <EmptyState
        icon={<Warning2 size={40} color="currentColor" variant="Bulk" />}
        title="Something went wrong"
        description="An unexpected error occurred while displaying this page. Reload to try again; if the problem continues, contact support."
        primaryAction={<Button onClick={() => window.location.reload()}>Reload</Button>}
      />
    </div>
  );
}
